import styled from 'styled-components';
import {Assign} from 'utility-types';

// TYPES
import {ThemeProps} from 'styled-components';

// COMPONENTS
import {Link} from 'react-router-dom';

// THEME

export const ArrowWrapper = styled.span(
  props => `
  height: 1rem;
  width: 1rem;
  font-size:${props.theme.font.small};
  padding: 0 ${props.theme.spacing.base};
  color: ${props.theme.colors.downriver.dark};
`,
);

export const BreadCrumbContainer = styled.div(
  // itemscope and item type are html attributes directly passed to section
  props => `
  display: flex;
  width: 100%;
  flex-direction: row;
`,
);

export const BreadCrumbList = styled.ol`
  list-style-type: none;
  display: flex;
  align-items: center;
`;

export const BreadCrumbItemLink = styled(Link)(
  props => `
  display: flex;
  cursor: pointer;
  font-size:${props.theme.font.base};
  text-decoration: none;
  color: ${props.theme.colors.goBrandBlue.base}
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base}
  }
  &.active{
    color: ${props.theme.colors.goWhite.base}
  }
`,
);

export const BreadCrumbATagItemLink = styled.a(
  props => `
  display: flex;
  cursor: pointer;
  font-size:${props.theme.font.base};
  text-decoration: none;
  color: ${props.theme.colors.goBrandBlue.base}
  &:hover{
    color: ${props.theme.colors.goBrandBlue.base}
  }
  &.active{
    color: ${props.theme.colors.goWhite.base}
  }
`,
);

export const NoLinkBreadcrumbListItem = styled.li(
  props => `
  display: flex;
  font-size:${props.theme.font.base};
  text-decoration: none;
  color: ${props.theme.colors.downriver.base}
`,
);
